import { Address } from 'framework/address'
import { Order } from 'framework/orders'

type FazendinhaOrder = {
  id: number
  cliente_id: number
  forma_pagamento_id: number
  subtotal: string
  total_frete: string
  total_desconto: string
  total: string
  created_at: string
  updated_at: string
  status_financeiro: 'PENDENTE' | 'AGUARDANDO-PAGAMENTO' | 'PAGO'
  shipping_address: any
  observacao: string
}

export default function parser(payload: FazendinhaOrder): Order {
  // const payload = order.pedido
  // @ts-ignore
  const endereco = payload?.shipping_address || null
  // const x = JSON.parse(payload)
  return {
    id: payload.id.toString(),
    method: payload.forma_pagamento_id === 1 ? 'creditCard' : 'ticket',
    subTotal: parseFloat(payload.subtotal),
    shippingTotal: parseFloat(payload.subtotal),
    discount: parseFloat(payload.subtotal),
    total: parseFloat(payload.total),
    createdAt: new Date(payload.created_at),
    status: payload.status_financeiro,
    note: payload.observacao || '',
    shippingAddress: {
      id: endereco ? endereco.id.toString() : '1',
      zipCode: endereco ? endereco.cep : '',
      city: {
        name: endereco ? endereco.cidade : '',
        district: endereco ? endereco.uf : '',
        id: endereco ? endereco.id.toString() : '1',
      },
      number: '',
      neighborhood: endereco ? endereco.bairro : '',
      complement: endereco ? endereco.complemento : '',
      street: endereco ? endereco.logradouro : '',
      type: 'ENTREGA',
      active: true,
    } as Address,
  }
}
